import { MouseEventHandler } from "react";
import chevronLeft from "@assets/icon-chevron-left.svg";
import chevronRight from "@assets/icon-chevron-right.svg";
import cx from "classnames";

type ArticleMainImageArrowProps = {
  direction: "left" | "right";
  onClick?: MouseEventHandler | undefined;
};

export default function ArticleMainImageArrow({
  direction = "left",
  onClick,
}: ArticleMainImageArrowProps): React.ReactElement {
  const icon = direction === "left" ? chevronLeft : chevronRight;

  return (
    <div
      className={cx(
        "absolute top-1/2 z-10 flex h-7 w-7 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-gray-250",
        {
          "right-0 mr-4": direction === "right",
          "left-0 ml-4": direction === "left",
        }
      )}
    >
      <img src={icon} width={18} height={18} onClick={onClick} />
    </div>
  );
}
